import axios from 'axios';
import { useCallback } from 'react';
import { notify } from '../components/UI/notify';
import { NotifyType } from '../types/enums/notifytype';

// Assuming you're using fetch to make API calls 
const token = localStorage.getItem("access_token");

const nexapi = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API base URL
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}` // Attach token in Authorization header
  },
});
 
const {message} = notify();

 
   
nexapi.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('access_token');  

        if (!token) {
          console.error('No token available. Request blocked.');
          return Promise.reject({ message: 'No authentication token available' });
        }

        config.headers.Authorization = `Bearer ${token}`;
        return config;
      },
      (error) => Promise.reject(error)
    );

nexapi.interceptors.response.use(
  response => {     
    return response;
  },
  error => {
 
   
    if (error.response) {
      // Server responded with a status other than 2xx
      console.error('Error Response:', error.response);
      //message(NotifyType.Error, `Error occured in api call: ${error.response.data}`);
      switch (error.response.status) {
        case 401:
          // Handle unauthorized
          //console.log('Unauthorized! Redirecting to login...');
          localStorage.clear();
          //message(NotifyType.Error, "Unauthorized! Redirecting to login...");
          // window.location.href = '/NotFound';
          // Optionally redirect to login page
          break;
        case 403:
          // Handle forbidden
          //console.log('Forbidden! Access denied.');
          break;
        case 404:
          // Handle not found
          //console.log('Resource not found!');
          break;
        case 500:
          // Handle server error
          //console.log('Server error! Please try again later.');
          //message(NotifyType.Error, 'Server error! Please try again later.');
          break;
        default:
          //message(NotifyType.Error, 'Unexpected error:');
          //console.log('Unexpected error:', error.response.data.message || 'An error occurred.');
      }
    } else if (error.request) {
      // No response was received
      //message(NotifyType.Error, `Error occured in api call: ${error.message}`);
      console.error('No response received:', error.request);
    } else {       
      //message(NotifyType.Error, 'Error setting up request:');
      console.error('Error setting up request:', error.message);
    }

      return Promise.reject(error);
  }
);


export default nexapi;
